<template>
	<view class="detail">
		<view :class="info.type === 1?'head head1':'head head0'" :style="{ height: statusbarHeight + navHeight + 'px' }">
			<view :style="{width: '100%', height: statusbarHeight + 'px'}"></view>
			<view class="head-nav" :style="{width: '100%', height: navHeight + 'px'}">
				<image src="/static/icon/nav_ic_back.png" mode="widthFix"  @click="goBack"></image>
				<text>寄存订单</text>
				<image src="/static/icon/nav_ic_back.png" @click="goBack" mode="widthFix" style="opacity: 0;"></image>
			</view>
		</view>
		<view :style="{ width: '100%', height: statusbarHeight + navHeight + 'px' }"></view>
		<view :class="info.type === 1?'nr head1':'nr head0'">
			<view class="nr-status">
				<text>{{info.statusName|| ''}}</text>
				<view class="nr-status-type1" v-if="info.type === 0">就地寄存</view>
				<view class="nr-status-type"  v-if="info.type === 1">同城寄送</view>
				<view class="nr-status-type1"  v-if="info.type === 1 && info.isUrgent === 0">标速达</view>
				<view class="nr-status-type1"  v-if="info.type === 1 && info.isUrgent === 1">极速达</view>
				<view class="nr-status-type2" v-if="info.type === 0 && info.exceptionStatus === 1">异常转存</view>
			</view>
			<view class="item" style="padding: 10rpx;" v-if="info.type ===1 && info.status===4">
				<map 
					name="mapAddr"
					:latitude="mapLat" 
					:longitude="mapLng" 
					:scale="mapScale" 
					:markers="markers" 
					:polyline="polyline"
					show-location
					style="width: 100%; height: 362rpx;"
				></map>
			</view>
			<view class="item">
				<view class="addr">
					<view class="addr-item">
						<view class="ji bg">寄</view>
						<view class="xiantiao"></view>
						<view class="addr-item-top">
							<text>{{info.depositShopName || ''}}</text>
						</view>
						<text style="width: 70%;">{{info.depositShopAddress || ''}}  </text>
						<view class='addr-link' style="top: 0;" @click="contactPhoneDo(info.takePhone)">
							<image style="margin-right: 10rpx;" src="/static/icon/ic_call@2x.png" mode="widthFix"  ></image>
							<text class=" txt-d1">联系客户</text>
						</view>
					</view>
					<view class="addr-item" v-if="info.type === 1">
						<view class="ji bg1">收</view>
						<view class="addr-item-top">
							<text>{{info.takeShopName || info.takeLocation || ''}}</text> 
						</view>
						<text>{{info.takeShopAddress || ''}}  </text>
					</view>
				</view>
				<view class="item-x"></view>
				<view class="item-list">
					<view class="item-list-row">
						<view class="item-form-label">收件人</view>
						<view class="item-form-val">{{info.takeUser || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">收件人电话</view>
						<view class="item-form-val">{{info.takePhone || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">到店寄存时间</view>
						<view class="item-form-val">{{info.expectedDepositTime || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">预计取件时间</view>
						<view class="item-form-val">{{info.expectedTakeTime || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">物品名称</view>
						<view class="item-form-val">{{info.goodTypeName || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">物品照片</view>
						<view class="item-form-list" v-if="info.orderImages && info.orderImages.length">
							<view class="item-form-list-row" v-for="(item,index) in info.orderImages" key="item">
								<image :src="item" mode="widthFix" @click="previewImage(info.orderImages,index)"></image>
							</view> 
						</view>
					</view>
				</view>
				<view class="addr" v-if="info.driverPhone">
					<view class="addr-item">
						<view class="ji bg">送</view>
						<view class="addr-item-top">
								<text class=" txt-d">司机：{{info.driverName || '战神'}} </text>
						</view>
						<view class='addr-link' style="top: 0;" @click="contactPhoneDo(info.driverPhone)">
							<image style="margin-right: 10rpx;" src="/static/icon/ic_call@2x.png" mode="widthFix"  ></image>
							<text class=" txt-d1">联系司机</text>
						</view>
						
					</view>
				</view>
			</view>
			
		<!-- 	<view class="item" v-if="info.refundInfo">
				<view class="tuikuan">
					<view class="tuikuan-top">
						<text>退款金额</text>
						<text>¥{{((info.refundInfo.refundAmount || 0)/100).toFixed(2)}}</text>
					</view>
					<view class="tuikuan-bottom">
						<text v-if="info.refundInfo.status === 0">退款中</text>
						<text v-if="info.refundInfo.status  === 1">已退回您的支付账户</text>
						<text v-if="info.refundInfo.status  === 2">退款失败</text>
						<text v-if="info.refundInfo.status  === 1">{{info.refundInfo.refundTime || ''}}</text>
						<text v-if="info.refundInfo.status  !== 1">{{info.refundInfo.createTime || ''}}</text>
					</view>
				</view>
			</view> -->
			<view class="item" v-if="info.commentStatus === 1">
				<view class="comment">
					<view class="comment-top">
						<text>客户已评价：</text>
					</view>
					<view class="comment-score">
						<view class="score-item" v-if="info.depositScore">寄件门店: <text style="color:#ffc533;font-size: 38rpx;margin-right: 10rpx;">★</text>{{info.depositScore || 1}} </view>
						<view class="score-item"  v-if="info.driverScore">配送司机: <text style="color:#ffc533;font-size: 38rpx;margin-right: 10rpx;">★</text>{{info.driverScore || 1}} </view>
						<view  class="score-item" v-if="info.takeScore">收件门店: <text style="color:#ffc533;font-size: 38rpx;margin-right: 10rpx;">★</text>{{info.takeScore || 1}} </view>
					</view>
					<view class="comment-row" v-if="info.commentImages && info.commentImages.length" >
						<view class="comment-image"  v-for="(item,index) in info.commentImages" key="item">
							<image :src="item" mode="widthFix" @click="previewImage(info.commentImages,index)"></image>
						</view> 
					</view>
				</view>
			</view>
			<view class="item" v-if="info.refundInfo">
				<view class="tuikuan">
					<view class="tuikuan-top">
						<text>退款金额</text>
						<text>¥{{((info.refundInfo.refundAmount || 0)/100).toFixed(2)}}</text>
					</view>
					<view class="tuikuan-bottom">
						<text v-if="info.refundInfo.status === 0">退款中</text>
						<text v-if="info.refundInfo.status  === 1">已退回您的支付账户</text>
						<text v-if="info.refundInfo.status  === 2">退款失败</text>
						<text v-if="info.refundInfo.status  === 1">{{info.refundInfo.refundTime || ''}}</text>
						<text v-if="info.refundInfo.status  !== 1">{{info.refundInfo.createTime || ''}}</text>
					</view>
				</view>
			</view>			
			<view class="item" v-if="info.detailList">
				<view class="xl">
					<view v-for="goods in info.detailList " :key="goods.luggageName" class="xl-item">
						<view class="xl-item-top">
							<text>{{ goods.luggageName ||'' }}</text>
							<text>¥{{((goods.subtotal || 0)/100).toFixed(2) }}</text>
						</view>
						<view class="xl-item-bottom">
							<text>{{ goods.luggageDetail || '' }}</text>
							<text>x{{ goods.num || 1}}</text>
						</view>
					</view> 
				</view>
				<view class="item-x"></view>
				<view class="item-list">
					<view class="item-list-row">
						<view class="item-form-label" style="color: #333333; font-size: 28rpx;">保价金额</view>
						<view class="item-form-val" style="color: #333333; font-size: 24rpx;">¥{{((info.declaredAmount || 0)/100).toFixed(2)}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label" style="color: #333333; font-size: 28rpx;">行李保费</view>
						<view class="item-form-val" style="color: #333333; font-size: 24rpx;">¥{{((info.declaredFee || 0)/100).toFixed(2)}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label" style="color: #333333; font-size: 28rpx;">优惠金额</view>
						<view class="item-form-val" style="color: #333333; font-size: 24rpx;">¥{{((info.deductionAmount || 0)/100).toFixed(2)}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label" style="color: #222222; font-size: 30rpx; font-weight: 600;">实付款</view>
						<view class="item-form-val price" style="color: #FE2C2E; font-size: 36rpx;">{{((info.actualPayAmount || 0)/100).toFixed(2)}}</view>
					</view>
				</view>
			</view>
			<view class="item">
				<view class="item-title">订单信息</view>
				<view class="item-infos">
					<view class="item-infos-item">
						<view class="item-infos-item-left">订单编号：</view>
						<view class="item-infos-item-right">
							<text>{{info.code ||''}}</text>
							<image src="/static/icon/ic_cppy@2x.png" mode="widthFix" @tap="copyCode(info.code||'')"></image>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">创建时间：</view>
						<view class="item-infos-item-right">
							<text>{{info.createTime ||''}}</text>
						</view>
					</view>
					<view class="item-infos-item" v-if="info.payTime">
						<view class="item-infos-item-left">支付时间：</view>
						<view class="item-infos-item-right">
							<text>{{info.payTime ||''}}</text>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">支付方式：</view>
						<view class="item-infos-item-right">
							<text>微信支付</text>
						</view>
					</view>
					<view class="item-infos-item" v-if="info.outTradeNo">
						<view class="item-infos-item-left">交易单号：</view>
						<view class="item-infos-item-right">
							<text>{{info.outTradeNo || ''}}</text>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">订单备注：</view>
						<view class="item-infos-item-right">
							<text>{{info.remark || ''}}</text>
						</view>
					</view>
					<view class="item-infos-item" v-if="info.refundTime">
						<view class="item-infos-item-left">申请退款：</view>
						<view class="item-infos-item-right">
							<text>{{info.refundTime || ''}}</text>
						</view>
					</view>
				</view>
			</view>
			<view style="width: 100%; height: calc(210rpx + env(safe-area-inset-bottom));"></view>
		</view>
		<view class="tips" v-if="info.overdueStatus !==0 &&info.overdueStatus !==2">
			<image src="/static/icon/ic_waring@2x.png" mode="widthFix"></image>
			<text  v-if="info.overdueStatus ===1">已超过取件时间，已产生超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text> 
			<text  v-if="info.overdueStatus ===3">已超过取件时间，等待客户支付超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text>
			<text  v-if="info.overdueStatus ===4">超过取件时间，已支付超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text>
		</view> 
		<view class="footer" >
			<view class="footer-btns">
				<view class="btn kong" @click="contactPhoneDo(info.takePhone)" v-if="info.status === 1 || info.status === 5" >联系客户</view>
				<view class="btn kong" @click="openTrackPopup">订单轨迹</view>
				<view class="btn kong" @click="contactPhoneDo(info.driverPhone)" v-if="info.type ===1&&(info.status === 4 || info.status === 3)">联系骑手</view>
				<!-- <view class="btn you"  v-if="[1,4].includes(info.status) && info.takeShopId" @click="hexiaoOrder(info)" >收件核销</view> -->

				<view class="btn you" v-if="(info.status === 1 && (shopInfo.id == info.depositShopId)) || (info.status === 4 && (shopInfo.id == info.takeShopId))" @click="hexiaoOrder(info)" >收件核销</view>

				<view class="btn you"  v-if="info.status>0||info.status<=7  "   @click="printerOrder(info)" >打印标签</view>
				<view class="btn you" v-if="info.status ===5 &&(info.overdueStatus ==0 || info.overdueStatus == 1) && info.takeShopId" @click="hexiaoOrder(info)" >确认到店</view>
				<view class="btn you" v-if="info.status ===5 && (info.overdueStatus == 4 || info.overdueStatus == 2)" @click="hexiaoOrder(info)" >取件核销</view>
			</view>
		</view>
		<u-popup :show="showCancel" round="15" :safeAreaInsetBottom="false" mode="center">
			<view class="tc">
				<view class="tc-contemt">
					<view class="tc-contemt-title">确定取消提醒</view>
					<view class="tc-contemt-nr">
						您确认取消该订单吗？
					</view>
				</view>
				<view class="tc-btn">
					<view class="tc-btn-item" @click="showCancel = false;currentOrder=null;">我再想想</view>
					<view class="tc-btn-item" style="color: red;" @click="cancelOrderDo">确认取消</view>
				</view>
			</view>
		</u-popup>
		<u-popup :show="showTrackPopup" mode="bottom" round="24" :safeAreaInsetBottom="true" :closeOnClickOverlay="true" @close="closeTrackPopup">
			<view class="track-popup">
				<view class="track-popup__header">
					<text class="track-popup__title">订单轨迹</text>
					<view class="track-popup__close" @click="closeTrackPopup">×</view>
				</view>
				<scroll-view scroll-y class="track-popup__body">
					<view class="track-empty" v-if="!trackList.length">暂无轨迹信息</view>
					<view class="track-list" v-else>
						<view class="track-item" v-for="(track, index) in trackList" :key="track.key || index">
							<view class="track-item__content">
								<view class="track-item__rail">
									<image v-if="index === 0" class="track-item__dot track-item__dot--active" src="/static/icon/dian.png" mode="aspectFit"></image>
									<view v-else class="track-item__dot"></view>
									<view class="track-item__line" v-if="index !== trackList.length - 1"></view>
								</view>
								<view class="track-item__body">
									<text class="track-item__time">{{ track.time }}</text>
									<text class="track-item__desc">{{ track.title }}</text>
									<view class="track-item__images" v-if="track.images && track.images.length">
										<image
											v-for="(img, imgIndex) in track.images"
											:key="track.key + '-' + imgIndex"
											:src="img"
											mode="aspectFill"
											@click="previewImage(trackList[index].images, imgIndex)"
										></image>
									</view>
								</view>
							</view>
						</view>
					</view>
				</scroll-view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	import drawQrcode from 'weapp-qrcode'
	var amapFile = require('@/utils/amap-wx.130.js')

	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight', 'shopInfo'])
		},
		data() {
			return {
				loading:false,
				id:null,
				qrcodeImage:null,
				showCancel:false,
				showTrackPopup:false,
				trackList: [],
				info:{},
				mapLat: 0,
				mapLng: 0,
				mapScale: 12,
				markers: [],
				polyline: []
			}
		},
		// onShow() {
		// 	this.showCancel=false
		// 	this.trackList = []
		// 	this.info={} 
		// 	this.getOrderDetail() 
		// },
		onLoad(options) {
			this.id = options.id
			this.showCancel=false
			this.trackList = []
			this.info={} 
			this.getOrderDetail() 
		},
		methods:{
			async openTrackPopup() {
				uni.showLoading({
					title: '加载中...',
					mask: true
				})
				let success = false
				try {
					success = await this.getOrderTimeline()
				} finally {
					uni.hideLoading()
				}
				if (success) {
					this.showTrackPopup = true
				}
			},
			closeTrackPopup() {
				this.showTrackPopup = false
			},
			async getOrderTimeline() {
				if (!this.id) {
					this.trackList = []
					return false
				}
				try {
					let res = await this.$u.api.shopTimeline(this.id)
					if (res.code === 200) {
						let list = Array.isArray(res.data) ? res.data : []
						this.trackList = list.map((item, index) => ({
							key: item.id || item.time || index,
							title: item.title || '',
							time: item.time || '--',
							images: this.normalizeTrackImages(item.images)
						}))
						return true
					}
					this.trackList = []
					uni.showToast({
						title: res.msg || '获取轨迹失败',
						icon: 'none'
					})
					return false
				} catch (e) {
					this.trackList = []
					uni.showToast({
						title: '获取轨迹失败',
						icon: 'none'
					})
					return false
				}
			},
			normalizeTrackImages(images) {
				if (!Array.isArray(images)) {
					return []
				}
				return images.filter(item => !!item)
			},
			previewImage(images,index = 0) {
				console.log(images)
				console.log(index)
				uni.previewImage({
					current: index, 
					urls: images,
					fail(err) {
						console.log(err)
					}
				});
			},
			hexiaoOrder(item){
				uni.navigateTo({
					url:'/shop/pages/write-off/write-off'
				})
			},
			contactPhoneDo(phone){ 
				if(phone !=null &&phone!=''){
					uni.makePhoneCall({
					   phoneNumber:phone
					})
				}
			},
			cancelOrder(item){
				this.showCancel = !this.showCancel
			}, 
			async printerOrder(){
				if(this.loading){
					return
				}
				this.loading =true
				try{
					var that =this
					 that.$u.api.printOrderLabel({ orderId: this.id }).then(res=>{
						 if (res.code === 200 ) {
							 uni.showToast({
							 	title:'发起打印请求成功',
								icon:'none'
							 })
						 } 
						 that.loading =false
					 })
				}catch(e){
					this.loading =false
				} 
				
			},
			async cancelOrderDo(){
				var that =this
				let res = await that.$u.api.cancelOrder({ orderId: this.id });
				if (res.code === 200 ) { 
					this.showCancel = false
					uni.$emit('updateOrder',{info:this.info,delete:0})
					that.getOrderDetail()
				} 
			},
			 async showQrcodeImg(){
			 	if((this.info.type ===0 && this.info.status >=1 &&this.info.status <7) 
			 	|| (this.info.type ===1 && (this.info.status ===1 || (this.info.takeShopId && this.info.status ===5)))){
			 		if(this.qrcodeImage){
			 			return
			 		}
			 		this.qrcodeImage=null
			 		var that =this
			 		drawQrcode({
			 			canvasId: 'qrcodeCanvas',
			 			text: this.info.memberVerifyCode,
			 			width: 180,
			 			height: 180,
			 			correctLevel: 2
			 		})
					this.$nextTick(() => {
						uni.canvasToTempFilePath({
							canvasId: 'qrcodeCanvas',
							success: (res) => {
								that.qrcodeImage = res.tempFilePath
							}
						}, this)
					})
			 		// setTimeout(() => {
			 		// 	uni.canvasToTempFilePath({
			 		// 		canvasId: 'qrcodeCanvas',
			 		// 		success: (res) => {
			 		// 			that.qrcodeImage = res.tempFilePath
			 		// 		}
			 		// 	}, this)
			 		// }, 100)
			 	}
			 	 
			 },
			copyCode(txt) {
				if (!txt) {
					return
				}
				uni.setClipboardData({
					data: txt,
					success: () => {
						uni.showToast({
							title: '已复制到粘贴板',
							icon: 'none'
						})
					}
				})
			},
			  
			goBack(){
				uni.navigateBack({delta:-1})
			},
			async  getOrderDetail(){
				var that =this 
				let res = await this.$u.api.shopOrderDetail( {orderId:this.id} )
				if (res.code === 200) { 
					this.info = res.data 
					uni.$emit('updateOrder',{info:this.info,delete:0})
					if (this.info.type === 1 && this.info.status === 4) {
						this.getRoutePlanning()
					}
				} 
			},
			getRoutePlanning() {
				var that = this
				var driverLat = this.info.driverLat
				var driverLng = this.info.driverLng
				var depositShopLat = this.info.depositShopLat
				var depositShopLng = this.info.depositShopLng
				
				console.log('getRoutePlanning called', driverLat, driverLng, depositShopLat, depositShopLng)
				
				if (!driverLat || !driverLng || !depositShopLat || !depositShopLng) {
					console.log('坐标缺失')
					return
				}
				
				this.mapLat = driverLat
				this.mapLng = driverLng
				
				var myAmapFun = new amapFile.AMapWX({ key: this.$gaodeMapKey })
				myAmapFun.getDrivingRoute({
					origin: driverLng + ',' + driverLat,
					destination: depositShopLng + ',' + depositShopLat,
					success: function(data) {
						console.log('获取路径规划成功 data:', data)
						console.log('data keys:', Object.keys(data))
						console.log('data.paths:', data.paths)
						console.log('driverLng:', driverLng, 'driverLat:', driverLat, 'depositShopLng:', depositShopLng, 'depositShopLat:', depositShopLat)
						var points = []
						var duration = 0
						if (data.paths && data.paths.length > 0) {
							var path = data.paths[0]
							duration = path.duration || 0
							console.log('path:', path)
							console.log('path keys:', Object.keys(path))
							
							var steps = path.steps || path.routs || path.roads || []
							if (steps.length === 0 && path.distance) {
								steps = [path]
							}
							
							console.log('steps:', steps)
							
							if (steps && steps.length > 0) {
								for (var i = 0; i < steps.length; i++) {
									var step = steps[i]
									console.log('step:', step)
									console.log('step keys:', step ? Object.keys(step) : 'null')
									
									var polylineStr = step.polyline || step.Polyline || step.path || step.line || step.road || ''
									console.log('polylineStr:', polylineStr)
									
									if (!step || !polylineStr) continue
									var stepPoints = polylineStr.split(';')
									if (!stepPoints || stepPoints.length === 0) continue
									for (var j = 0; j < stepPoints.length; j++) {
										if (!stepPoints[j]) continue
										var point = stepPoints[j].split(',')
										if (!point || point.length < 2) continue
										points.push({
											latitude: parseFloat(point[1]),
											longitude: parseFloat(point[0])
										})
									}
								}
							}
						}
						console.log('points:', points)
						
						var expectedTime = ''
						if (duration > 0) {
							var now = new Date()
							var arrivalTime = new Date(now.getTime() + duration * 1000)
							var month = arrivalTime.getMonth() + 1
							var day = arrivalTime.getDate()
							var hours = arrivalTime.getHours()
							var minutes = arrivalTime.getMinutes()
							expectedTime = month + '.' + (day < 10 ? '0' + day : day) + ' ' + (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes)
						}
						
						that.polyline = [{
							points: points,
							color: '#00c47c',
							width: 10,
							arrowLine: true
						}]
						console.log('polyline set:', that.polyline)
						
						that.markers = [
							{
								id: 1,
								latitude: parseFloat(driverLat),
								longitude: parseFloat(driverLng),
								iconPath: '/static/icon/start.png',
								width: 30,
								height: 40,
								anchor: { x: 0.5, y: 1 }
							},
							{
								id: 2,
								latitude: parseFloat(depositShopLat),
								longitude: parseFloat(depositShopLng),
								iconPath: '/static/icon/end.png',
								width: 30,
								height: 40,
								anchor: { x: 0.5, y: 1 }
							},
							{
								id: 3,
								latitude: parseFloat(driverLat),
								longitude: parseFloat(driverLng),
								iconPath: '/static/icon/dizhi.png',
								width: 24,
								height: 30,
								anchor: { x: 0.5, y: 0.5 },
								callout: {
									content: '预计到店时间\n' + expectedTime,
									color: '#222222',
									fontSize: 14,
									borderRadius: 4,
									padding: 8,
									display: 'ALWAYS',
									bgColor: '#ffffff'
								}
							}
						]
						
						if (points.length > 0) {
							that.mapLat = points[Math.floor(points.length / 2)].latitude
							that.mapLng = points[Math.floor(points.length / 2)].longitude
						}
					},
					fail: function(err) {
						console.error('获取路径规划失败', err)
						that.markers = [
							{
								id: 1,
								latitude: parseFloat(driverLat),
								longitude: parseFloat(driverLng),
								iconPath: '/static/icon/start.png',
								width: 30,
								height: 40,
								anchor: { x: 0.5, y: 1 }
							},
							{
								id: 2,
								latitude: parseFloat(depositShopLat),
								longitude: parseFloat(depositShopLng),
								iconPath: '/static/icon/end.png',
								width: 30,
								height: 40,
								anchor: { x: 0.5, y: 1 }
							}
						]
					}
				})
			}
			
		}
	}
</script>
<style>
	page {
		background-color: #F8F9FB;
	}
</style>
<style lang="scss" scoped>
	.detail {
		width: 100%;
		.tips {
			width: 100%;
			height: 80rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			background: #FFE9E9;
			position: fixed;
			bottom: calc(30rpx + env(safe-area-inset-bottom));
			left: 0;
			display: flex;
			align-items: center;
			image {
				width: 28rpx;
				height: 28rpx;
				margin-right: 16rpx;
			}
			text {
				font-weight: 400;
				font-size: 26rpx;
				color: #FF0000;
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			padding: 0 30rpx;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			z-index: 9;
			background-color: #ffffff;
			.footer-btns {
				width: 100%;
				height: 100rpx;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.kong {
					border: 1rpx solid #B2B2B2;
					font-weight: 400;
					font-size: 28rpx;
					color: #666666;
				}
				.you {
					background: #10B2FA;
					font-weight: 400;
					font-size: 28rpx;
					color: #FFFFFF;
				}
				.btn {
					width: 160rpx;
					height: 64rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 32rpx;
					margin-left: 20rpx;
				}
			}
		}
		.head0{
			background: #1ba8fa;
		}
		.head1{
			background: #E4730B;
		}
		.track-popup {
			background: #FFFFFF;
			border-radius: 24rpx 24rpx 0 0;
			padding: 24rpx 24rpx calc(24rpx + env(safe-area-inset-bottom));
			box-sizing: border-box;
			.track-popup__header {
				height: 88rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
			}
			.track-popup__title {
				font-size: 40rpx;
				font-weight: 600;
				color: #222222;
			}
			.track-popup__close {
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				width: 56rpx;
				height: 56rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 56rpx;
				line-height: 1;
				color: #A5A7AD;
			}
			.track-popup__body {
				height: 50vh;
			}
			.track-empty {
				line-height: 50vh;
				text-align: center;
				font-size: 28rpx;
				color: #999999;
			}
			.track-list {
				padding: 12rpx 0 0;
			}
			.track-item {
				position: relative;
			}
			.track-item__rail {
				width: 34rpx;
				flex-shrink: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				align-self: stretch;
				position: relative;
			}
			.track-item__dot {
				width: 16rpx;
				height: 16rpx;
				flex-shrink: 0;
				position: relative;
				z-index: 1;
				border-radius: 50%;
				background: #CCCCCC;
				margin-top: 12rpx;
			}
			.track-item__dot--active {
				width: 32rpx;
				height: 32rpx;
				flex-shrink: 0;
				display: block;
				position: relative;
				z-index: 1;
				margin-top: 4rpx;
				background: transparent;
			}
			.track-item__line {
				width: 2rpx;
				position: absolute;
				left: 50%;
				top: 28rpx;
				bottom: -30rpx;
				transform: translateX(-50%);
				background: #E6EAF0;
			}
			.track-item__content {
				display: flex;
				align-items: flex-start;
				column-gap: 22rpx;
				padding: 0 0 20rpx;
			}
			.track-item__body {
				flex: 1;
				min-width: 0;
			}
			.track-item__time {
				display: block;
				font-size: 28rpx;
				font-weight: 400;
				color: #8A8F99;
				line-height: 1.4;
			}
			.track-item__desc {
				display: block;
				margin-top: 22rpx;
				font-weight: 500;
				font-size: 30rpx;
				color: #666666;
			}
			.track-item__images {
				display: flex;
				flex-wrap: wrap;
				gap: 18rpx;
				margin-top: 24rpx;
				image {
					width: 130rpx;
					height: 130rpx;
					border-radius: 12rpx;
					background: #F3F5F8;
				}
			}
		}
		.head {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 9;
			.head-nav {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				image {
					width: 48rpx;
					height: 48rpx;
				}
				text {
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
				}
			}
		}
		.nr {
			width: 100%;
			height: 264rpx;
			padding: 22rpx 30rpx;
			box-sizing: border-box;
			// background-color: #E4730B;
			.nr-status {
				display: flex;
				align-items: baseline;
				text {
					font-weight: 600;
					font-size: 36rpx;
					color: #FFFFFF;
					margin-right: 16rpx;
				}
				.nr-status-type {
					width: 154rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #FA8010;
				}
				.nr-status-type2 {
					width: 158rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #FF0000;
					margin-left: 16rpx;
				}
				.nr-status-type1 {
					width: 158rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #10B2FA;
					margin-left: 16rpx;
				}
			}
			.nr-desc {
				font-weight: 400;
				font-size: 26rpx;
				color: #FFFFFF;
				margin-top: 12rpx;
			}
			.item {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 30rpx;
				map {
					width: 100%;
					height: 362rpx;
					border-radius: 16rpx;
				}
				.addr {
					width: 100%;
					display: flex;
					flex-direction: column;
					.addr-link{
						position: absolute;
						    top: 10rpx;
						    right:0px;
						    display: inline-block;
					}
					.addr-item {
						padding-left: 58rpx;
						box-sizing: border-box;
						position: relative;
						margin-bottom: 40rpx;
						&:last-child {
							margin-bottom: 0 !important;
						}
						.txt-d{
							font-weight: 400  !important;
							font-size: 30rpx  !important;
							color: #333333;
							line-height: 42rpx;
							text-align: left;
							font-style: normal;
						}
						.txt-d1{
							font-weight: 400  !important;
							font-size: 26rpx !important;
							color: #333333;
							line-height: 36rpx;
							text-align: left;
							font-style: normal;
						}
						image{
							width: 22rpx;
							margin-left: 22rpx;
						}
						.bg {
							background: #10B2FA;
						}
						.bg1 {
							background-color: #FA8010;
						}
						.xiantiao {
							width: 2rpx;
							height: 100%;
							position: absolute;
							top: 24px;
							left: 20rpx;
							border-right: 2rpx dashed #E5E5E5;
						}
						.ji {
							position: absolute;
							top: 10rpx;
							left: 4rpx;
							width: 40rpx;
							height: 40rpx;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 50%;
							font-weight: 400;
							font-size: 26rpx;
							color: #FFFFFF;
						}
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
							margin-top: 10rpx;
						}
						.addr-item-top {
							display: flex;
							align-items: center;
							text {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							image {
								width: 13rpx;
								margin-left: 12rpx;
							}
						}
					}
				}
				.xl {
					width: 100%;
					.xl-item {
						width: 100%;
						margin-bottom: 26rpx;
						&:last-child {
							margin: 0 !important;
						}
						.xl-item-top {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							text {
								font-weight: 600;
								font-size: 28rpx;
								color: #333333;
							}
						}
						.xl-item-bottom {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-top: 12rpx;
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #8C939F;
							}
						}
					}
				}
				.comment{
					width: 100%;
					display: flex;
					flex-direction: column;
					.comment-top {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 36rpx;
								color: #FE2C2E;
								&:before {
									content: "￥";
									font-weight: 500;
									font-size: 24rpx;
									color: #FE2C2E;
								}
							}
						}
					}
					.comment-score{
						// font-weight: 600;
						font-size: 28rpx;
						color: #333333;
						margin: 10rpx 0;
						display: flex;
						width: 100%;
						.score-item{
							flex:1;
							margin: 20rpx 0;
						}
					}
					.comment-row{
						display: flex;
						flex-wrap: wrap;
						.comment-image {
							margin: 10rpx;
							width: 100rpx;
							height: 100rpx;
							border-radius: 8rpx;
							border:1px solid #f2f2f2;
							overflow: hidden;
							image {
								width: 100%;
							}
						}
					}
					
				}
				.tuikuan {
					width: 100%;
					display: flex;
					flex-direction: column;
					.tuikuan-top {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 36rpx;
								color: #FE2C2E;
								&:before {
									content: "￥";
									font-weight: 500;
									font-size: 24rpx;
									color: #FE2C2E;
								}
							}
						}
					}
					.tuikuan-bottom {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 8rpx;
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #666666;
						}
					}
				}
				.item-qrcode {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					margin-top: 40rpx;
					image {
						width: 360rpx;
						height: 360rpx;
					}
					text {
						&:nth-child(2) {
							font-weight: 600;
							font-size: 36rpx;
							color: #222222;
							margin-top: 12rpx;
						}
						&:nth-child(3) {
							font-weight: 400;
							font-size: 26rpx;
							color: #999999;
							margin-top: 12rpx;
						}
					}
				}
				.item-x {
					width: 100%;
					height: 1rpx;
					margin: 30rpx 0;
					background-color: #E5E5E5;
				}
				.item-title {
					font-weight: 600;
					font-size: 30rpx;
					color: #222222;
				}
				.item-infos {
					width: 100%;
					margin-top: 18rpx;
					.item-infos-item {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.item-infos-item-left {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
						.item-infos-item-right {
							display: flex;
							align-items: center;
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #666666;
							}
							image {
								width: 24rpx;
								margin-left: 16rpx;
							}
						}
					}
				}
				.item-list {
					width: 100%;
					.item-list-row {
						width: 100%;
						margin-bottom: 24rpx;
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						&:last-child {
							margin-bottom: 0 !important;
						}
						.item-form-label {
							width: 300rpx;
							flex-shrink: 0;
							font-weight: 400;
							font-size: 26rpx;
							color: #666666;
						}
						.item-form-val {
							font-weight: 400;
							font-size: 26rpx;
							color: #333333;
						}
						.price {
							&:before {
								content: "￥";
								font-weight: 400;
								font-size: 24rpx;
								color: #FE2C2E;
							}
						}
						.item-form-list {
							max-width: 360rpx;
							display: flex;
							flex-wrap: wrap;
							align-items: center;
							justify-content: space-between;
							gap: 20rpx;
							.item-form-list-row {
								width: 88rpx;
								height: 88rpx;
								border-radius: 8rpx;
								overflow: hidden;
								image {
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
